export * from './attachment-placement-details';
